/**
 * Alphanumeric sorting
 */
export const alphanumeric = (row1, row2, columnName) => {
  // get the values to compare
  const rowOneColumn = row1.values[columnName];
  const rowTwoColumn = row2.values[columnName];
  if (typeof rowOneColumn === 'string') {
    return rowOneColumn.localeCompare(rowTwoColumn, undefined, {
      ignorePunctuation: true,
    });
  }
  return Number(rowOneColumn) > Number(rowTwoColumn) ? 1 : -1;
};
